import { AUTH_REDUCER_KEY } from 'store/auth/constants'

export const isImpersonatingSelector = state => state[AUTH_REDUCER_KEY].impersonate.isImpersonating
